<template>
  <b-row class="pl-4 pr-4 pb-3">
    <b-col lg="6" md="6">
      <label class="label-form" for="delegaciones">{{ $t("label.delegaciones.opcionales") }}</label>
      <span id="delegaciones" class="data-form" v-if="ofertaDemanda.isAllDelegations">
        {{ $t("label.todas") }}
      </span>
      <template v-else>
        <div id="delegaciones">
          <template v-for="(delegacion, index) in delegaciones">
            <div v-if="index < 5" :key="delegacion.id">
              <span class="data-form">{{ delegacion.desDelegacion }}</span>
            </div>
          </template>
          <div v-if="delegaciones.length > 5">
            <span class="data-form">{{ $t("label.masOpciones", [delegaciones.length - 6]) }}</span>
          </div>
          <b-tooltip
            v-if="delegaciones.length > 5"
            target="delegaciones"
            placement="bottom"
            custom-class="my-tooltip"
          >
            {{ delegacionesString }}
          </b-tooltip>
        </div>
      </template>
    </b-col>
  </b-row>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";
import { IDelegacion, IOfertaDemanda } from "@/entities";
import VueMethods from "@/vue-methods";

@Component({
  name: "delegaciones-opcionales",
  mixins: [VueMethods],
})
export default class DelegacionesOpcionales extends Vue {
  @Prop({ required: true }) ofertaDemanda!: IOfertaDemanda;

  get delegaciones(): IDelegacion[] {
    return (
      this.ofertaDemanda.ubicaciones
        ?.map((ubicacion) => {
          return ubicacion.delegacion;
        })
        .filter((delegacion) => delegacion.id !== this.ofertaDemanda.clientexdel.delegacion.id)
        .sort((a, b) => this.sortAscending(a, b, "desDelegacion")) ?? []
    );
  }

  get delegacionesString(): string {
    return this.delegaciones.map((delegacion) => delegacion.desDelegacion).join(", ");
  }
}
</script>

<style lang="scss" scoped>
.my-tooltip {
  max-width: 600px;
}
.recent-label {
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 30px;
  letter-spacing: normal;
  color: var(--secundario-prosegur-claro);
}
.label-form {
  font-size: 12px;
  line-height: 16px;
  font-weight: normal;
  color: var(--secundario-prosegur-oscuro-plus-10);
  margin-bottom: 0;
}
.data-form {
  font-size: 14px;
  font-weight: bold;
  line-height: 16px;
  color: var(--secundario-prosegur-claro);
  text-transform: initial;
}

.btn-number {
  border-color: transparent;
  background-color: rgba(0, 0, 0, 0.03);
}

.card {
  margin: 0 0 0 0.75rem;
}

.card span {
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
  width: 99%;
  overflow: hidden;
}

.card span:hover {
  white-space: normal;
}

.card-body {
  margin: 0;
  padding: 0;
}

.card-header,
.card-text {
  padding: 1rem;
}

.move-panel {
  transition: all 1.5s ease-in-out;
  transform: translate(-25vw, 0);
}
</style>
